var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconA11yLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconA11y",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M960 2c529.355 0 960 430.645 960 960s-430.645 960-960 960S0 1491.355 0 962 430.645 2 960 2Zm0 112.941c-467.125 0-847.059 379.934-847.059 847.059 0 467.125 379.934 847.059 847.059 847.059 467.125 0 847.059-379.934 847.059-847.059 0-467.125-379.934-847.059-847.059-847.059Zm436.704 520.291h-914.56c-31.04 0-55.467 24.427-55.467 55.467 0 31.146 24.427 55.573 55.467 55.573h275.307v887.787c0 31.146 24.32 55.573 55.466 55.573 31.04 0 55.467-24.427 55.467-55.573v-375.04h146.453v375.04c0 31.146 24.427 55.573 55.467 55.573 31.147 0 55.573-24.427 55.573-55.573V744.032h275.307c31.04 0 55.467-24.427 55.467-55.467-6.72-28.906-31.04-53.333-59.947-53.333m-457.29-315.21c73.6 0 133.226 59.626 133.226 133.226 0 73.493-59.627 133.12-133.227 133.12-73.493 0-133.226-59.627-133.226-133.12 0-73.6 59.733-133.227 133.226-133.227",
        fillRule: "evenodd"
      }))
    });
  }
}
IconA11yLine.glyphName = 'a11y';
IconA11yLine.variant = 'Line';
IconA11yLine.displayName = 'IconA11yLine';
IconA11yLine.allowedProps = [...SVGIcon.allowedProps];
export default IconA11yLine;
export { IconA11yLine };